var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-menu-list-container"},_vm._l((_vm.list),function(item,index){return _c('menu-item',{key:index,attrs:{"item":item},on:{"clickComplex":function($event){return _vm.clickComplex(index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }